// extracted by mini-css-extract-plugin
module.exports = {"width":"index-module_width_1B75H"};